import { render, staticRenderFns } from "./PlayerBids.vue?vue&type=template&id=08ebb100&scoped=true&"
import script from "./PlayerBids.vue?vue&type=script&lang=js&"
export * from "./PlayerBids.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBids.vue?vue&type=style&index=0&id=08ebb100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebb100",
  null
  
)

export default component.exports